const reportMessages = {
  report: {
    header: {
      title: '報告書一覧',
      button: {
        create: '作成',
      },
    },
    list: {
      action: {
        description: 'チェックした項目を',
        download: 'ダウンロード',
      },
      header: {
        number: '報告書No',
        subject: '件名',
        status: 'ステータス',
        author: '作成者',
        createDate: '作成日',
        lastModifiedBy: '最終更新者',
        lastModifiedDate: '最終更新日',
      },
      pagination: {
        unit: '件',
      },
    },
    detail: {
      title: '報告書詳細',
      section: {
        title: '報告書プレビュー',
      },
      url: {
        copy: 'URLコピー',
        copyComplete: 'URLをコピーしました。',
      },
      info: {
        number: '報告書No',
        subject: '件名',
        status: 'ステータス',
        views: '閲覧数',
        unit: ' 件',
        author: '作成者',
        creationDate: '作成日',
        lastUpdatedBy: '最終更新者',
        lastUpdatedDate: '最終更新日',
      },
      pdf: {
        error: 'PDFファイルの読み込みに失敗しました。',
        page: '{currentPage}/{totalPages} ページ',
      },
      download: 'ダウンロード',
    },
    edit: {
      header: {
        title: '報告書編集',
        lastModifiedDate: '最終更新日時：{dateTime}',
        status: 'ステータス',
      },
      action: {
        return: '一覧へ戻る',
        preview: 'プレビュー',
        statusChange: '変更',
      },
      info: {
        number: '報告書No.',
        subject: '報告書件名',
        author: '作成者',
        creationDate: '作成日',
        picture: {
          placeholder: 'クリックして写真を選ぼう',
          noImage: 'No Images',
        },
      },
      status: {
        confirmation: {
          header: '報告書を{statusName}にする',
          message: {
            published: '報告書をメンバーに共有しますがよろしいですか？',
            complete:
              '報告書を完了にすると編集できなくなりますがよろしいですか？',
          },
          button: {
            ok: '{statusName}にして保存',
          },
        },
      },
      selectMediaDialog: {
        title: '写真を選択',
        checkbox: {
          label: '自分が撮影したデータのみ表示する',
        },
      },
      conflictDialog: {
        title: '他のユーザーによって編集されました',
        message1: '編集中の内容が他のユーザーにより編集・保存されました。',
        message2: '自身の編集を残す場合は「上書き」を、自身の編集を破棄し、',
        message3:
          '他のユーザーの内容を残す場合には「破棄」を選択してください。',
      },
      statusConflictDialog: {
        message1: '編集中の内容が他のユーザーにより編集・保存されました。',
        message2: '自分の編集を残しステータスを完了にする場合は「上書き」を、',
        message3:
          '他のユーザーの内容を残す場合には「破棄」を選択してください。',
      },
      frame: {
        placeholder: '報告文章を記載してください。',
      },
      deleteConfirmDialog: {
        title: '削除確認',
        message: 'フレームを削除しますか？',
      },
    },
    status: {
      create: '下書き',
      published: '共有',
      complete: '完了',
    },
  },
};

export default reportMessages;
